/* global layer */
export function dialog1(title, content, closeAll=false){
    if(closeAll) layer.closeAll();
    layer.open({
        title ,content
    });    
}
export function dialog2(msg, closeAll=false){
    if(closeAll) layer.closeAll();
    layer.msg(msg, {icon: 1}); 
}
export function dialog3(title, content, closeAll=false){
    if(closeAll) layer.closeAll();
    layer.open({
        type: 2 //此处以iframe举例
        ,title: '当你选择该窗体时，即会在最顶端'
        ,area: ['390px', '260px']
        ,shade: 0
        ,maxmin: true
        ,content: '//layer.layui.com/test/settop.html'
        ,btn: ['继续弹出', '全部关闭'] //只是为了演示
        ,yes: function(){
          alert(1);
        }
        ,btn2: function(){
          alert(2);
        }
        
        ,zIndex: layer.zIndex //重点1
        ,success: function(layero){
          layer.setTop(layero); //重点2
        }
    });
}
export function dialog4(title, content, yesfunction=()=>{}, closeAll=false){
    if(closeAll) layer.closeAll();
    layer.open({
        type: 1
        ,id: 'mustlogin1' //防止重复弹出
        ,title
        ,content: '<div style="padding: 20px 100px;">'+ content +'</div>'
        ,btn: ['现在登录', "取消"]
        ,btnAlign: 'c' //按钮居中
        ,yes: function(index){
          layer.close(index);
          yesfunction();
        }
    }, {
        icon : 3
    });
}
export function dialog5(content){
    layer.msg(content);
}
export function dialog6(content){
    layer.msg(content);
}